module.exports = __webpack_public_path__ + "media/images/icons/outlined/audio-e2547305dcae4db16c06b2de9b23b975.svg";